import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { StatisticsIntervalTypeEnum } from '@app/common';
import { STATISTIC_INTERVALS } from '../../../models/stores/statistic/statistic-store';
import { Switcher } from '../switcher/switcher';
import { PeriodSwitcherSkeleton } from './skeleton/period-switcher-skeleton';

type PeriodSwitcherType = {
    value: StatisticsIntervalTypeEnum;
    onChange: (type: StatisticsIntervalTypeEnum) => Promise<void> | void;
    loading?: boolean;
    excludedTypes?: StatisticsIntervalTypeEnum[];
};
export const PeriodSwitcher: React.FC<PeriodSwitcherType> = observer(
    ({ value, onChange, loading, excludedTypes }: PeriodSwitcherType) => {
        const intervals = useMemo(() => {
            return STATISTIC_INTERVALS.filter((period) => !excludedTypes?.includes(period.type));
        }, [excludedTypes]);

        if (loading) {
            return <PeriodSwitcherSkeleton excludedTypes={excludedTypes} />;
        }

        return (
            <div className="flex w-full justify-start overflow-x-auto overflow-y-hidden [-webkit-overflow-scrolling:touch] [scrollbar-width:none] xl:justify-end [&::-webkit-scrollbar]:hidden">
                <div className="inline-flex">
                    <Switcher
                        value={value}
                        options={intervals.map((period) => ({
                            value: period.type,
                            label: period.title,
                        }))}
                        activeColor="primary"
                        onChange={async (periodType) => {
                            await onChange(periodType);
                        }}
                    />
                </div>
            </div>
        );
    },
);
